module.exports = __webpack_public_path__ + "media/IllustrationBackground/Background-b2a3134b.svg";